<form [formGroup]="detailsForm">
    <div class="row header">
        <h5 *ngIf="mode === 'create'">
            {{
                "admin.toolMaintenancePlans.recurrences.create" | translate
            }}
        </h5>
        <h5 *ngIf="mode === 'edit'">
            {{
                "admin.toolMaintenancePlans.recurrences.edit" | translate
            }}
        </h5>
        <div class="mutators">
            <app-icon *ngIf="mode === 'edit'" library="fontawesome" type="danger" variant="fa-trash"
                      (click)="onDelete()"></app-icon>
            <app-icon library="fontawesome" variant="fa-times" (click)="onClose()"></app-icon>
        </div>
    </div>

    <app-loading-spinner class="loader" *ngIf="loading"></app-loading-spinner>

    <div class="row" *ngIf="!loading">
        <div class="col s12">
            <app-input
                formControlName="name"
                [formControl]="detailsForm.controls.name"
                [showErrors]="showValidations"
                placeholder="{{
                    'admin.toolMaintenancePlans.recurrences.details.name.label'
                        | translate
                }}"
                label="{{
                    'admin.toolMaintenancePlans.recurrences.details.name.placeholder'
                        | translate
                }}"
            >
            </app-input>
        </div>
    </div>

    <div class="row" *ngIf="!loading">
        <app-dropdown
            formControlName="type"
            [formControl]="detailsForm.controls.type"
            [items]="recurrenceTypes"
            [showErrors]="showValidations"
            displayField="label"
            valueField="id"
            label="{{
                    'admin.toolMaintenancePlans.recurrences.details.type.label'
                        | translate
                }}"
            emptyText="{{
                    'admin.toolMaintenancePlans.recurrences.details.type.label'
                        | translate
                }}"
            (selectItem)="onTypeUpdate($event)"
        ></app-dropdown>
    </div>

    <div
        class="row"
        *ngIf="(type === 'Cycle' || type === 'Time') && !loading">
        <div class="col"
             [class.s6]="type == 'Time'"
             [class.s12]="type == 'Cycle'">
            <app-input
                formControlName="value"
                [formControl]="detailsForm.controls.value"
                [showErrors]="showValidations"
                placeholder="{{
                    'admin.toolMaintenancePlans.recurrences.details.value.label'
                        | translate
                }}"
                label="{{
                    'admin.toolMaintenancePlans.recurrences.details.value.placeholder'
                        | translate
                }}"
            >
            </app-input>
        </div>
        <div class="col s6"
             *ngIf="type == 'Time'">
            <app-dropdown
                formControlName="unit"
                [formControl]="detailsForm.controls.unit"
                [items]="units"
                [showErrors]="showValidations"
                displayField="label"
                valueField="id"
                label="{{
                    'admin.toolMaintenancePlans.recurrences.details.unit.label'
                        | translate
                }}"
                emptyText="{{
                    'admin.toolMaintenancePlans.recurrences.details.unit.placeholder'
                        | translate
                }}"
                (selectItem)="onUnitUpdate($event)"
            ></app-dropdown>
        </div>
    </div>
    <div class="row" *ngIf="!loading">
        <app-button type="primary"
                    (click)="onConfirm()">
            {{ "admin.toolMaintenancePlans.recurrences.button" | translate }}
        </app-button>
    </div>
</form>
